module.exports = __webpack_public_path__ + "img/stripe.784e6d0b.svg";